import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { mainComponent } from './Components/main/main.component';


const appRoutes: Routes = [
    {
        path: '',
        component: mainComponent        
    }
];
// Registrer
export const appRoutingProviders: any[] = [

];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes, { useHash: true });



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/app.routing.ts
 **/